import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const printReceipt = (data) => {
    const dateTime = new Date().toLocaleString();
    let dishesArray = []

    if (Array.isArray(data.dishes)) {
        data.dishes.forEach((entry) => {
            try {
                const parsed = JSON.parse(entry);
                if (Array.isArray(parsed)) {
                    dishesArray = dishesArray.concat(parsed);
                }
            } catch (e) {
                console.error("Invalid dish format in receipt", e);
            }
        });
    }

    let receipt = `Receipt\n\n`;
    receipt += `Customer: ${data.name}\n`;
    receipt += `Phone: ${data.phone}\n`;
    receipt += `Table: ${data.table} #${data.Number}\n\n`;
    receipt += `Items:\n`;
    receipt += `Food Name         Unit Price    Total Price\n`;

    dishesArray.forEach((item) => {
        const itemType = item.type || "";
        const itemName = item.name || "";
        const unitRate = item.rate || 0;
        const qty = item.quantity || 0;
        const total = unitRate * qty;

        const nameStr = `${itemType} - ${itemName} X ${qty}`.padEnd(20);
        const unitStr = `Rs: ${unitRate}`.padEnd(15);
        const totalStr = `Rs: ${total}`;

        receipt += `${nameStr}${unitStr}${totalStr}\n`;
    });

    const total = parseFloat(data.totalPrice) || 0;
    const sgst = (total * 2.5) / 100;
    const cgst = (total * 2.5) / 100;
    const grandTotal = total + sgst + cgst;

    receipt += `\nSubtotal: ₹${total}\n`;
    receipt += `SGST: ₹${sgst.toFixed(2)}\n`;
    receipt += `CGST: ₹${cgst.toFixed(2)}\n`;
    receipt += `Grand Total: ₹${grandTotal.toFixed(2)}\n`;
    receipt += `Date: ${dateTime}\n`;

    const printFrame = document.createElement('iframe');
    printFrame.style.position = 'absolute';
    printFrame.style.left = '-9999px';
    document.body.appendChild(printFrame);

    const doc = printFrame.contentWindow.document;
    doc.open();
    doc.write(`<html><head><title>Receipt</title></head><body><pre>${receipt}</pre></body></html>`);
    doc.close();

    printFrame.contentWindow.focus();
    printFrame.contentWindow.print();

    setTimeout(() => {
        document.body.removeChild(printFrame);
    }, 1000);
};

export default function PrintRecipt() {
    const location = useLocation()
    const data = JSON.parse(location.state.data)

    useEffect(() => {
        printReceipt(data);
    }, [data]);

    return null;
}
